import { combineReducers } from "redux";
import auth from "./auth";
import notification from "./notifications";
import alert from "./alerts";
import page from "./pages";

export default combineReducers({
  auth,
  alert,
  notification,
  page
});
